import { render, staticRenderFns } from "./SuggestionListWrapper.vue?vue&type=template&id=7d01400b&scoped=true&"
import script from "./SuggestionListWrapper.vue?vue&type=script&lang=js&"
export * from "./SuggestionListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionListWrapper.vue?vue&type=style&index=0&id=7d01400b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d01400b",
  null
  
)

export default component.exports